// import { Auth } from "aws-amplify";
import store from "@/store";
import generateUser from "@/bin/aws/generateUser";
// import userService from "@/services/repositories/userRepository";
async function fetchUser(to, from, next) {
  store.commit("setLoading", true);
  console.log("[AUTH]User...");
  const d = Date.now();
  if (!store.getters["getAWSUser"]) {
    await generateUser({ cache: true });
    store.commit("setLoading", false);
    next();
  } else {
    store.commit("setLoading", false);
    next();
    await generateUser();
  }
  console.log("[AUTH]Middleware Done", Date.now() - d);
}
export default fetchUser;
